"use strict";

var __awaiter = this && this.__awaiter || function (o, s, a, u) {
  return new (a || (a = Promise))(function (e, t) {
    function n(e) {
      try {
        r(u.next(e));
      } catch (e) {
        t(e);
      }
    }

    function i(e) {
      try {
        r(u.throw(e));
      } catch (e) {
        t(e);
      }
    }

    function r(t) {
      t.done ? e(t.value) : new a(function (e) {
        e(t.value);
      }).then(n, i);
    }

    r((u = u.apply(o, s || [])).next());
  });
},
    __generator = this && this.__generator || function (n, i) {
  var r,
      o,
      s,
      e,
      a = {
    label: 0,
    sent: function sent() {
      if (1 & s[0]) throw s[1];
      return s[1];
    },
    trys: [],
    ops: []
  };
  return e = {
    next: t(0),
    throw: t(1),
    return: t(2)
  }, "function" == typeof Symbol && (e[Symbol.iterator] = function () {
    return this;
  }), e;

  function t(t) {
    return function (e) {
      return function (t) {
        if (r) throw new TypeError("Generator is already executing.");

        for (; a;) {
          try {
            if (r = 1, o && (s = 2 & t[0] ? o.return : t[0] ? o.throw || ((s = o.return) && s.call(o), 0) : o.next) && !(s = s.call(o, t[1])).done) return s;

            switch (o = 0, s && (t = [2 & t[0], s.value]), t[0]) {
              case 0:
              case 1:
                s = t;
                break;

              case 4:
                return a.label++, {
                  value: t[1],
                  done: !1
                };

              case 5:
                a.label++, o = t[1], t = [0];
                continue;

              case 7:
                t = a.ops.pop(), a.trys.pop();
                continue;

              default:
                if (!(s = 0 < (s = a.trys).length && s[s.length - 1]) && (6 === t[0] || 2 === t[0])) {
                  a = 0;
                  continue;
                }

                if (3 === t[0] && (!s || t[1] > s[0] && t[1] < s[3])) {
                  a.label = t[1];
                  break;
                }

                if (6 === t[0] && a.label < s[1]) {
                  a.label = s[1], s = t;
                  break;
                }

                if (s && a.label < s[2]) {
                  a.label = s[2], a.ops.push(t);
                  break;
                }

                s[2] && a.ops.pop(), a.trys.pop();
                continue;
            }

            t = i.call(n, a);
          } catch (e) {
            t = [6, e], o = 0;
          } finally {
            r = s = 0;
          }
        }

        if (5 & t[0]) throw t[1];
        return {
          value: t[0] ? t[1] : void 0,
          done: !0
        };
      }([t, e]);
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var rxjs_1 = require("rxjs"),
    DataBuilder_1 = require("../classes/DataBuilder"),
    InitialisationResponse_1 = require("../model/InitialisationResponse"),
    Initialisation = function () {
  function e(e) {
    this.url = "/config", this.subject = new rxjs_1.Subject(), this.sdk = e;
  }

  return e.prototype.setExpectedCodeType = function (e) {
    this.sdk.expectedCodeType = e;
  }, e.prototype.setExpectedSwipingGesture = function (e) {
    this.sdk.expectedSwipingGesture = e;
  }, e.prototype.loadData = function () {
    this.config();
  }, e.prototype.config = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, n, i, r;
      return __generator(this, function (e) {
        switch (e.label) {
          case 0:
            return t = navigator.userAgent, n = new DataBuilder_1.DataBuilder(this.sdk).buildJSONStringify(), i = {
              body: n,
              headers: {
                "Content-Type": "application/json",
                "user-agent": "" + t,
                "x-api-key": "" + this.sdk.getAPIKey()
              },
              method: "post"
            }, [4, this.sdk.getDataManager().fetch(this.url, i)];

          case 1:
            return (r = e.sent()) && (this.initialisationResponse = new InitialisationResponse_1.InitialisationResponse(r), this.setExpectedCodeType(this.initialisationResponse.codeSetTypes[0]), this.subject.next(this.initialisationResponse)), [2];
        }
      });
    });
  }, e;
}();

exports.Initialisation = Initialisation;